import { FormItemProps, Input } from 'antd';
import { TextAreaProps } from 'antd/lib/input';
import { TextAreaRef } from 'antd/lib/input/TextArea';
import React from 'react';
import { FormItem } from 'src/components/Form/FormItem';

export type TextAreaFieldProps = FormItemProps<string> & {
    label?: React.ReactNode;
    readOnly?: boolean;
    disabled?: boolean;
    maxLength?: number;
    textAreaProps?: TextAreaProps;
};

const DEFAULT_ROWS = 7;

export const TextAreaField = React.forwardRef<TextAreaRef, TextAreaFieldProps>(
    (
        {
            name,
            label,
            readOnly,
            disabled,
            maxLength,
            textAreaProps,
            ...props
        }: TextAreaFieldProps,
        ref,
    ) => {
        return (
            <FormItem {...props} name={name} label={label}>
                <Input.TextArea
                    maxLength={maxLength}
                    readOnly={readOnly}
                    disabled={disabled}
                    rows={DEFAULT_ROWS}
                    {...textAreaProps}
                    ref={ref}
                />
            </FormItem>
        );
    },
);
